import { observer } from 'mobx-react-lite'
import { Navigate, Route, Routes } from 'react-router'
import { CleanupRouter } from 'pages/contacts/pages/cleanup'
import { HistoryRouter } from 'pages/contacts/pages/history'
import { ContactsPage } from '../ui/contactsPage'
import { ContactsLayout } from '../layout/ContactsLayout'
import { ContactsPageLayout } from '../layout/ContactsPageLayout'
import { ContactProfileRoute } from './routes/ContactProfileRoute'
import { NewContactRoute } from './routes/NewContactRoute'
import { ImportRoute } from './routes/ImportRoute'
import { ContactsRoutes } from './type'

export const ContactsRouter = observer(() => {
  return (
    <Routes>
      <Route element={<ContactsLayout />}>
        <Route element={<ContactsPageLayout />}>
          <Route element={<ContactsPage />}>
            <Route index element={null} />
            <Route path={`${ContactsRoutes.all}`} element={null} />
            <Route path={`${ContactsRoutes.new}`} element={<NewContactRoute />} />
            <Route path={`${ContactsRoutes.import}`} element={<ImportRoute />} />
            <Route path={':id'} element={<ContactProfileRoute />} />
            <Route
              path={'*'}
              element={<Navigate to={`/${ContactsRoutes.root}/${ContactsRoutes.all}`} replace />}
            />
          </Route>
        </Route>
        <Route path={`${ContactsRoutes.history}`} element={<HistoryRouter />} />
        <Route path={`${ContactsRoutes.cleanup}`} element={<CleanupRouter />} />
        {/* ContactRouts.DUPLICATE and ContactRouts.UNLINKED are the old routs for cleanup in 1.0 */}
        <Route
          path={`${ContactsRoutes.duplicate}`}
          element={<Navigate to={`/${ContactsRoutes.root}/${ContactsRoutes.cleanup}`} replace />}
        />
        <Route
          path={`${ContactsRoutes.unlinked}`}
          element={<Navigate to={`/${ContactsRoutes.root}/${ContactsRoutes.cleanup}`} replace />}
        />
      </Route>
    </Routes>
  )
})
